import { motion } from "framer-motion";
import { PHOTOS } from "@/data/content";

const TITLES = [
  "International Bestselling Author",
  "Inspirational Speaker · Thought Leader",
  "Talk Show Host · Intuitive Medium",
];

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-[#FDFAF4]"
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.img
        src={PHOTOS.meetSusan}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
        initial={{ opacity: 0, scale: 1.06 }}
        animate={{ opacity: 0.14, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1.6, ease: [0.76, 0, 0.24, 1] }}
      />

      <motion.div
        className="absolute inset-0 bg-white"
        initial={{ opacity: 0 }}
        exit={{ opacity: 1 }}
        transition={{ duration: 0.7, ease: "easeInOut" }}
        aria-hidden="true"
      />

      <motion.div
        className="relative flex flex-col items-center"
        exit={{ scale: 3, opacity: 0 }}
        transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
      >
        <motion.div
          animate={{ y: [0, -9, 0] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
        >
          <div className="flex overflow-hidden">
            {["S", "G"].map((l, i) => (
              <motion.span
                key={l}
                data-testid={`preloader-letter-${l}`}
                className="font-display text-[7rem] font-medium leading-none tracking-[0.08em] text-[#C5A059] md:text-[9rem]"
                initial={{ y: "110%", opacity: 0 }}
                animate={{ y: "0%", opacity: 1 }}
                transition={{ duration: 1, delay: 0.3 + i * 0.15, ease: [0.76, 0, 0.24, 1] }}
              >
                {l}
              </motion.span>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="mt-5 h-px bg-[#C5A059]"
          initial={{ width: 0 }}
          animate={{ width: 150 }}
          transition={{ duration: 0.9, delay: 0.95, ease: [0.76, 0, 0.24, 1] }}
        />

        <div className="mt-6 flex flex-col items-center gap-2 px-6 text-center">
          <motion.p
            className="font-body text-sm font-semibold uppercase tracking-[0.5em] text-[#6B5D4F]"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 1.15 }}
          >
            Healer
          </motion.p>
          {TITLES.map((t, i) => (
            <motion.p
              key={t}
              className="font-body text-[0.6rem] font-medium uppercase tracking-[0.35em] text-[#8B7D6B]"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 1.32 + i * 0.14 }}
            >
              {t}
            </motion.p>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
}
